export enum VossUseRevenueRecognition {
    Inherit = 0,
    Enabled = 1,
    Disabled = 2,
}

export const VossUseRevenueRecognitionText: Record<VossUseRevenueRecognition, string> = {
    [VossUseRevenueRecognition.Inherit]: 'vossUseRevenueRecognition.inherit',
    [VossUseRevenueRecognition.Enabled]: 'vossUseRevenueRecognition.enabled',
    [VossUseRevenueRecognition.Disabled]: 'vossUseRevenueRecognition.disabled',
};

export const revenueRecognitionModes = Object.keys(VossUseRevenueRecognitionText).map(Number) as VossUseRevenueRecognition[];
